import React, { Component } from "react";
import { Box, Paper, RadioGroup, FormControlLabel, Radio, Typography } from "@mui/material";

import PaymentInsertForm from "./PaymentInsertForm";
import TransactionsInsertForm from "./TransactionsInsertForm";

class PaymentTransaction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "payment" // payment | transaction
    };
  }

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };
 componentWillMount() {
        document.title = "VR Builders - Payments";
        
   	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Payments";   
			 this.props.parentsCallback(
           strname
        );
         const params = new URLSearchParams(window.location.search);
  let id = params.get("ts_id");
      let psid = params.get("ps_id");
	  
	  if(psid!==null)
	  {
		  this.setState({ type:"payment"});
	  }
	  else if(id!==null)
	  {
		  this.setState({ type:"transaction"});
	  }
    }
  render() {
   

    return (
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 2, mb: 2 }}>

       

          {/* RADIO BUTTON */}
          <RadioGroup
            row
            value={this.state.type}
            onChange={this.handleTypeChange}
          >
            <FormControlLabel
              value="payment"
              control={<Radio />}
              label="Customer Payment"
            />

            <FormControlLabel
              value="transaction"
              control={<Radio />}
              label="Vendor Transaction"
            />
          </RadioGroup>

        </Paper>

        {/* FORM SWITCH */}
        <Paper sx={{ p: 2 }}>
          {this.state.type === "payment" ? (
            <PaymentInsertForm />
          ) : (
            <TransactionsInsertForm />
          )}
        </Paper>

      </Box>
    );
  }
}

export default PaymentTransaction;